import { render, staticRenderFns } from "./DentalAppointmentHistoryForm.vue?vue&type=template&id=3699abe9&"
import script from "./DentalAppointmentHistoryForm.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports